import { useMutation } from "react-query";
import { executeJob } from "../../../../actions/Utilities/JobConfig";

const useExecuteJob = () => {
  return useMutation(executeJob);
};
export default useExecuteJob;
